document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth <= 1000;
    const desktopVideos = document.querySelectorAll(".desktop-video-pd-off video");
    const mobileVideos = document.querySelectorAll(".mobile-video-reel-pd-off video");

    const allVideos = [...desktopVideos, ...mobileVideos];

    const playVideoIfInViewport = (video) => {
        const rect = video.getBoundingClientRect();
        // Check if the video is fully or partially in the viewport
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
            if (video.paused) {
                video.muted = true; // Ensures autoplay works without sound
                video.playsInline = true;
                video.play().catch(() => {}); // Play the video if it's in the viewport
            }
        }
    };

    // Immediately check if videos are in the viewport when the page loads
    allVideos.forEach(playVideoIfInViewport);

    // Create an IntersectionObserver to handle scroll events after page load
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target;
            const isDesktopVideo = video.closest('.desktop-video-pd-off') !== null;
            const isMobileVideo = video.closest('.mobile-video-reel-pd-off') !== null;

            const shouldLoadAndPlay = (
                (isMobile && isMobileVideo) || (!isMobile && isDesktopVideo)
            );

            // If the video is at least 50% visible, play it
            if (entry.intersectionRatio >= 0.5 && shouldLoadAndPlay && video.readyState >= 2) {
                if (video.paused) {
                    video.muted = true; // To ensure autoplay works without sound
                    video.playsInline = true;
                    video.play().catch(() => {});
                }
            } else {
                // Pause the video if it's less than 50% visible
                if (!video.paused) {
                    video.pause();
                }
            }
        });
    }, {
        threshold: [0.05, 0.5]  // Trigger the observer at 5% and 50% visibility
    });

    // Observe all videos for future scroll events
    allVideos.forEach(video => {
        observer.observe(video);
    });
});
